import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { APP_URL_HOME } from '../../../../const';
import { getUserUnreadMessages } from '../../../../store/slices/authSlice';
import { getUserMenuState, toggleSidebarCollapsed, toggleUserMenu } from '../../../../store/slices/globalSlice';
//import BurgerIcon from '../../../icons/BurgerIcon';
import LogoIcon from '../../../icons/LogoIcon';
import TopBurgerIcon from '../../../icons/TopBurgerIcon';
import styles from './styles.module.scss';

// matchMedia probe — true if the viewport is at least the tablet
// breakpoint where the sidebar takes over from the drawer. Re-read
// at click time so a resize between renders still routes correctly.
const isDesktopViewport = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(min-width: 768px)').matches;
};

const Header = (props) => {
    const dispatch = useDispatch();
    const isMenuOpened = useSelector(getUserMenuState);
    const unreadMessages = useSelector(getUserUnreadMessages);
    const { isCatalogPage = false } = props;

    const handleBurgerClick = () => {
        // HORO-10326: on desktop the sidebar is permanent, so the hamburger
        // toggles its collapsed state instead of opening a drawer. Mobile
        // keeps the drawer.
        if (isDesktopViewport()) {
            dispatch(toggleSidebarCollapsed());
            return;
        }
        dispatch(toggleUserMenu(!isMenuOpened));
    };

    return (
        <header className={classNames(styles.header, styles.headerV2)}>
            <div className={classNames('container', { ['container-landing']: isCatalogPage })}>
                <div className={styles.wrapper}>
                    <button className={styles.burger} onClick={handleBurgerClick}>
                        {!!unreadMessages && <span className={styles.unread}></span>}
                        {/* HORO-10326: the burger glyph sits on a transparent
                            circle so it blends with the dark header / sidebar palette. */}
                        <TopBurgerIcon fill="transparent" />
                    </button>
                    <Link to={APP_URL_HOME} className={styles.logo} onClick={() => dispatch(toggleUserMenu(false))}>
                        <LogoIcon />
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Header;
